import { createFileRoute } from '@tanstack/react-router';

import { OperationsPage, opsOverviewQueryOptions } from '@/features/operations';

/** Every platform role reads it; owners and admins get "Reindex all". */
export const Route = createFileRoute('/_authed/operations')({
  staticData: { crumbKey: 'nav.operations', tours: ['platform.operations'] },
  // A failed prefetch is not fatal: the page renders the error inline and retries.
  loader: ({ context }) =>
    context.queryClient.query(opsOverviewQueryOptions()).catch(() => undefined),
  component: OperationsPage,
});
